// extracted by mini-css-extract-plugin
module.exports = {"dark":"Wrapper-module--dark--3h3WG","light":"Wrapper-module--light--7sepZ"};